import { render } from "./ShippingBillList.vue?vue&type=template&id=ed4e0684&scoped=true"
import script from "./ShippingBillList.vue?vue&type=script&lang=js"
export * from "./ShippingBillList.vue?vue&type=script&lang=js"

import "./ShippingBillList.vue?vue&type=style&index=0&id=ed4e0684&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4e0684"]])

export default __exports__